import React from 'react'
import { useAppSelector } from '../../Hooks'
import { selectUser } from '../../reducers/UserReducer'
import CheckRole from '../extras/CheckRole'
import EnergyAnalysisReportButton from './CustomerPageComponents/EnergyAnalysisReportButton'


const CustomerNavs: React.FC  = () => {
  const user = useAppSelector(selectUser)

  if (CheckRole(user,['Customer\n','Customer'])){
    return <>
      <EnergyAnalysisReportButton uuid={user.customer_id}/>
    </>
  }
  return null

}

export default CustomerNavs